module.exports = __webpack_public_path__ + "img/PayPal.svg.d7322833.png";